import React,{useContext} from 'react';
import styled from 'styled-components';
import { ServiceRequestContext } from '../../../../index';

const ErrorContainerDiv = styled.div`
background-color:#EEEEEE;
height:100%;
margin:0;
fontSize:.7em;
fontFamily:Arial,
`;

const ErrorHeaderDiv = styled.div`
margin: 0 0 0 0;
padding: 6px 2% 6px 2%;
font-family:Arial;
color: #FFF;
background-color: #555555;
`;

const ErrorBodyDiv = styled.div`
margin:0 0 0 2%;
position:relative;
`;

const ErrorBodyContainerDiv = styled.div`
background:#FFF;
width:96%;
margin-top:8px;
padding:10px;
position:relative;
`;

const ErrorHeading2 = styled.h2`
font-size:1.5em;
margin:0;
color:#CC0000;
`;

const ErrorHeading3 = styled.h3`
font-size:1.2em;
margin:10px 0 0 0;
color:#000000;
`;

export default function RequestServiceErrorHandling(){
    
    const {HasWOFormAccess, ServiceRequestDetails} = useContext(ServiceRequestContext);
    const isServiceRequestEnabled = ServiceRequestDetails.length ? ServiceRequestDetails[0].isServiceRequestEnabled : false;
    const NotFoundErrorMsg = <><ErrorHeading2>Error: 404 Page Not Found</ErrorHeading2>
                             <ErrorHeading3>Sorry, the page your looking for does not exist.</ErrorHeading3></>
    const ForbiddenErrorMsg = <><ErrorHeading2>Error: 403 Forbidden</ErrorHeading2>
                              <ErrorHeading3>This page is not accessible. For help, contact your Tracer Ensemble Administrator</ErrorHeading3></>
    const ErrorText = !HasWOFormAccess ? NotFoundErrorMsg : !isServiceRequestEnabled ? ForbiddenErrorMsg : null
    
    return(
     <ErrorContainerDiv>
      <ErrorHeaderDiv>
          <h1>Server Error</h1>
      </ErrorHeaderDiv>
      <ErrorBodyDiv>
          <ErrorBodyContainerDiv>
              <fieldset style={{border: '2px solid'}}>
                {ErrorText}
              </fieldset>
          </ErrorBodyContainerDiv>
      </ErrorBodyDiv>
      </ErrorContainerDiv>
    )
}